import type { V1Secret } from '@/generated/hooks/gringotts/models';

/** A managed credential (a Gringotts secret). */
export type TCredential = V1Secret;

/** Where a credential lives. Frozen at create. */
export enum ECredentialScope {
  Workspace = 'workspace',
  Organization = 'organization',
}

/**
 * A credential picker selection: an existing credential (by id, the value a
 * connection stores as `credentials_id`), or a new one created on submit.
 */
export type TCredentialSelection =
  | { mode: 'existing'; credentialId: string }
  | { mode: 'create' };

/** Values of the inline "create a credential" form. */
export interface ICredentialCreateFormValues {
  displayName: string;
  scope: ECredentialScope;
  /** Field id → value, keyed like the book's credential descriptors. */
  values: Record<string, string>;
}
